var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6",
    "data-name": "Group 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.357,
    height: 26.365,
    viewBox: "0 0 26.357 26.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-593.883-1285.906h13.59c.066.015.131.036.2.045a6.833,6.833,0,0,1,5.811,4.692,12.452,12.452,0,0,1,.374,1.646v13.59a2.182,2.182,0,0,0-.047.224,6.932,6.932,0,0,1-6.756,6.151q-6.382.038-12.764-.01a6.691,6.691,0,0,1-1.99-.342,6.887,6.887,0,0,1-4.8-6.636q-.008-6.176,0-12.352c0-.265.017-.531.043-.8a6.932,6.932,0,0,1,4.885-5.9C-594.862-1285.734-594.369-1285.8-593.883-1285.906Zm15.34,13.192q0-1.917,0-3.835a4.629,4.629,0,0,0-4.722-4.723q-3.822,0-7.643,0a4.63,4.63,0,0,0-4.724,4.722q0,3.822,0,7.643a4.631,4.631,0,0,0,4.722,4.724q3.822,0,7.643,0a4.63,4.63,0,0,0,4.724-4.722Q-578.541-1270.81-578.543-1272.714Z",
    transform: "translate(600.268 1285.906)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-466.493-1159.161q0,1.917,0,3.833a3.09,3.09,0,0,1-3.174,3.167q-3.833,0-7.667,0a3.089,3.089,0,0,1-3.16-3.155q0-3.846,0-7.693a3.089,3.089,0,0,1,3.161-3.153q3.846,0,7.693,0a3.087,3.087,0,0,1,3.147,3.141C-466.49-1161.734-466.493-1160.448-466.493-1159.161Zm-7.015,3.86a3.868,3.868,0,0,0,3.875-3.846,3.867,3.867,0,0,0-3.846-3.875,3.867,3.867,0,0,0-3.875,3.846A3.869,3.869,0,0,0-473.508-1155.3Zm4.431-7.516a.78.78,0,0,0,.781-.755.78.78,0,0,0-.748-.788.78.78,0,0,0-.794.768A.779.779,0,0,0-469.077-1162.817Z",
    transform: "translate(486.673 1172.34)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-385-1072.98a2.319,2.319,0,0,1-2.336,2.308,2.321,2.321,0,0,1-2.295-2.324,2.32,2.32,0,0,1,2.336-2.307A2.319,2.319,0,0,1-385-1072.98Z",
    transform: "translate(400.5 1086.165)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0ceb502195ac9b78c3330a320faeec03.svg";
export { ForwardRef as ReactComponent };